var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('report-image-damage-detail-card',{attrs:{"minimum":2,"screen":_vm.screen}})
}
var staticRenderFns = []

export { render, staticRenderFns }